export const maxMessageLength: number = 320;

export const maxMessageLengthWithConfirmation: number = 239;

export const EXAMPLE_CONFIRMATION_MESSAGE: string =
  ' Confirm or cancel: https://www.smsreminder.co/confirmation/ZwhFHBRK2wq9sM6KGME_M';

export const NO_CREDITS_EVENT_ERROR = 'No credits';
export const SUBSCRIPTION_CANCELLED_EVENT_ERROR = 'Subscription cancelled';
